import { render } from "./attention.vue?vue&type=template&id=04400638&ts=true"
import script from "./attention.vue?vue&type=script&lang=ts"
export * from "./attention.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__